import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
    getClientDatatableAsync, getClientDataByIAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, deleteClientAsync, updateClientsAsync,
    updateIsDisabledAsync, setClientActiveTab, updateSorting
} from './AccountClientSlice';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { ShowToast } from '../../common/Toastr';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import AccountClientForm from './AccountClientForm';
import { setItemStatus, getValueFromResource } from '../../common/timeLiveFunction';

const AccountClientItem = (props: any) => {
    const { t, IsEdit, IsDelete, onhandleOnClickEvent, IsList } = props;
    const { accountClientList, tab, sortOrder, sortColumn, pageSize,search } = useAppSelector((state) => state.accountClient);
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState)

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    const onEditClick = (AccountClientId: number) => {
        dispatch(getClientDataByIAsync({ AccountClientId: AccountClientId, decimalPlaces: decimalPlaces, cultureInfoName: cultureInfoName }))
            .unwrap()
            .then((originalPromiseResult) => {
            onhandleOnClickEvent({
                "name": getValueFromResource('Update Client', dispatch, t),
                "width": "700px",
                "componentName": <AccountClientForm t={t} />
            }, "Clients", true);

            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const navigateToClientSummary = (AccountClientId: number, AccountClientName: string) => {
        localStorage.setItem('objClient', JSON.stringify({ AccountClientId: AccountClientId, AccountClientName: AccountClientName }));
        navigate(`/accountpartysummary/${AccountClientId}`);
    }

    const navigateToClientAudit = (AccountClientId: any) => {
        const obj = {
            Id: AccountClientId,
            TableName: 'AccountParty',
            Title: getValueFromResource('Client Audit', dispatch, t)
        }
        // navigate('/accountaudit', { state: { obj } });
        navigate(`/accountaudit/${AccountClientId}`, { state: { obj } })

    }

    const onDeleteClick = (AccountClientId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteClientAsync(AccountClientId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Client Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const handleIsDisabledChange = (e: any, accountClient: any) => {
        const { checked } = e.target;
        const foundIndex = accountClientList.findIndex((item: any) => item.AccountPartyId === accountClient.AccountPartyId);
        if (foundIndex !== -1) {
            const foundItem = accountClientList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...accountClientList.slice(0, foundIndex), updatedItem, ...accountClientList.slice(foundIndex + 1)];
            dispatch(updateIsDisabledAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Client Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
    }

    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "start": 0,
            "pageSize": pageSize,
            "currentPage": 1
        }
        dispatch(updateSorting(objects));
        dispatch(getClientDatatableAsync({ currentPage: 1, pageSize: pageSize, start: 0, search: search }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1">
                <thead>
                    <tr className="thHeading align-middle">
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={accountClientList.every((item: any) => item.isSelected === 0) ? false :
                                            (accountClientList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }{IsEdit &&
                            <th style={{ width: '15%' }}>
                                {/* {t('Active / Inactive')} */}
                                {/* {handleResTerm('Active / Inactive')} */}
                              
                                {getValueFromResource('Active / Inactive',dispatch, t)}
                                {sortColumn === '1' ?
                                    sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                    </span>
                                    :
                                    // hoveredColumn === 1 && 
                                    <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                        <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                    </>}
                            </th>
                        }
                        <th style={{ width: '25%' }}>
                            {/* {t('Client Name')}  */}
                            {/* {handleResTerm('Client Name')} */}
                            {getValueFromResource('Client Name',dispatch, t)}
                            {sortColumn === '3' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 3 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Client Nick')}  */}
                            {/* {handleResTerm('Client Nick')} */}
                            {getValueFromResource('Client Nick',dispatch, t)}
                            {sortColumn === '2' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 2 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '20%' }}>
                            {/* {t('Email Address')}  */}
                            {/* {handleResTerm('Email Address')} */}
                            {getValueFromResource('Email Address',dispatch, t)}
                            {sortColumn === '4' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 4 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '10%' }}>
                            {/* {t('Country')}  */}
                            {/* {handleResTerm('Country')} */}
                            {getValueFromResource('Country',dispatch, t)}
                            {sortColumn === '5' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 5 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Telephone1')} */}
                            {/* {handleResTerm('Telephone1')} */}
                            {/* {getValueFromResource('Telephone1',dispatch, t)} */}
                            {getValueFromResource('Phone1',dispatch, t)}
                            {sortColumn === '6' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 6 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {accountClientList.length === 0 && <tr><td colSpan={8}><p className='noDataFound mt-2'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p></td></tr>}
                    {accountClientList.length > 0 && accountClientList.map((accountClientDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={accountClientDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, !accountClientDetail.AccountClientId ? accountClientDetail.AccountPartyId : accountClientDetail.AccountClientId) }}
                                        />
                                    </div>
                                </td>
                            }
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(accountClientDetail.IsDisabled === false ? "Active" : "InActive"))}>
                                    {accountClientDetail.IsDisabled === false ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td>
                                <a
                                    className='text-dark fw-bold d-block cursor'
                                    onClick={() => navigateToClientSummary(!accountClientDetail.AccountClientId ? accountClientDetail.AccountPartyId : accountClientDetail.AccountClientId, !accountClientDetail.ClientName ? accountClientDetail.PartyName : accountClientDetail.ClientName)}
                                >
                                    {!accountClientDetail.ClientName ? accountClientDetail.PartyName : accountClientDetail.ClientName}
                                </a>
                            </td>
                            <td>
                                <span className="d-block">
                                    {!accountClientDetail.ClientCode ? accountClientDetail.PartyNick : accountClientDetail.ClientCode}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {accountClientDetail.EMailAddress}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {accountClientDetail.Country}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {accountClientDetail.Telephone1}
                                </span>
                            </td>
                            {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        {/* <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={accountClientDetail.IsDisabled}
                                            onChange={(e) => { handleIsDisabledChange(e, accountClientDetail) }}
                                        /> */}

                                    </div>
                                </td>
                            }
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>

                                        {IsEdit &&
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item
                                                    id="kt_OffCanvas"
                                                    className="menu-item me-lg-0"
                                                    onClick={() => { onEditClick(!accountClientDetail.AccountClientId ? accountClientDetail.AccountPartyId : accountClientDetail.AccountClientId) }}
                                                >
                                                    <span className="menu-icon custom-menu mb-2">
                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">

                                                 {getValueFromResource('Edit',dispatch, t)}

                                                    </span>
                                                </Dropdown.Item>
                                            </div>
                                        }
                                        <div className='menu-hover-bg-sec'>
                                            <Dropdown.Item
                                                className="menu-item me-lg-0"
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title custom-menu-fontsize"
                                                    onClick={() => navigateToClientSummary(!accountClientDetail.AccountClientId ? accountClientDetail.AccountPartyId : accountClientDetail.AccountClientId, !accountClientDetail.ClientName ? accountClientDetail.PartyName : accountClientDetail.ClientName)}
                                                >
                                                     
                                                      {getValueFromResource('View Client',dispatch, t)}

                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                        <div className='menu-hover-bg-sec'>
                                            <Dropdown.Item
                                                className="menu-item me-lg-0"
                                                onClick={() => navigateToClientAudit(!accountClientDetail.AccountClientId ? accountClientDetail.AccountPartyId : accountClientDetail.AccountClientId)}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-receipt fs-6 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title custom-menu-fontsize">
                                               
                                                            {getValueFromResource('Audit',dispatch, t)}

                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75'></div>
                                        }
                                        {IsDelete &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0"
                                                        onClick={() => { onDeleteClick(!accountClientDetail.AccountClientId ? accountClientDetail.AccountPartyId : accountClientDetail.AccountClientId) }}
                                                    >
                                                        <span className="menu-icon  custom-menu mb-2">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>

                                                        <span className="menu-title delete-menu custom-menu-fontsize">
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                     


                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default AccountClientItem